<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">角色站位</a>
					</router-link>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row mb-3" v-if="benchmark.search_area_width != 0">
					<div class="col">
						<h3 class="item-title">
							基準點
						</h3>
						<div class="text-center">
							<img :src="'/static/images/unit/icon_unit_'+ (Number(benchmark.unit_id)+30) +'.png'" width="80" alt="">
							<br>
							{{benchmark.unit_name}}
							<br>
							{{benchmark.search_area_width}}
							<br>
							<button class="pcbtn mt-2" @click="benchmark.search_area_width = 0">移除</button>
						</div>
					</div>
				</div>
				<h3 class="item-title mb-3">角色站位順序</h3>
				<div class="row no-gutters">
					<div class="col-12 text-center">
						<div class="d-flex no-wrap chara-stand-box py-3">
							<div class="mr-3 chara-stand-item" v-for="(item,index) in unit_data" @mouseover="topBarMouseOver(item,index)" @mouseleave="topBarMouseLeave(item,index)" @click="changeBenchmark(item)" :id="item.unit_name">
								<img width="100" class="cursor-pointer" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
								<span style="font-size: 14px" v-html="replaceBrackets(item.unit_name)"></span>
								<br>
								<span style="font-size: 15px">{{getWidth(item.search_area_width)}}</span>
							</div>
						</div>
					</div>
					<div class="col-12" v-if="this.$parent.clientWidth > 1200">
						<div class="area-stand-box mb-3">
							<div class="unit-zone">
								<div @mouseenter="autoScroll(unit)" :style="getStyle(unit,index)" :id="'u'+unit.unit_id" class="pin" v-for="(unit,index) in unitHover">
									<img class="rounded-circle" :src="'/static/images/unit/icon_unit_'+ (Number(unit.unit_id)+30) +'.png'" alt="">
								</div>
							</div>
						</div>
						<p>註: Y軸高低非角色高低站位 只是排序</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Stand',
	data() {
		return {
			"benchmark": {
				"unit_name": "",
				"search_area_width": 0,
				"unit_id": ""
			},
			"unit_data": {},
			"standMode": 1,
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '角色站位順序表',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki'
	},
	methods: {
		getStyle: function(item, index) {
			var pleft = (900 - item.search_area_width) + (index * 1.6);
			var top = (index % 6) * 50;

			return { 'left': pleft + 'px', 'top': top + 'px' };
		},
		replaceBrackets: function(item, index) {
			var name = item;
			var sp = "";
			if (item.match(/\（([^)]+)\）/)) {
				sp = item.match(/\（([^)]+)\）/)[1];
				name = name.split("（")[0]
				return "(" + sp + ")" + "<br>" + name;
			}
			return name;
		},
		topBarMouseOver: function(item, index) {
			var unit_id = 'u' + item.unit_id;
			$("#" + unit_id).addClass("m-hover");
			$(".chara-stand-item").removeClass("select-box");
		},
		topBarMouseLeave: function(item, index) {
			var unit_id = 'u' + item.unit_id;
			$("#" + unit_id).removeClass("m-hover");
		},
		changeBenchmark: function(item) {
			this.benchmark.unit_name = item.unit_name;
			this.benchmark.search_area_width = Number(item.search_area_width);
			this.benchmark.unit_id = item.unit_id;
		},
		autoScroll: function(item) {
			location.href = "#" + item.unit_name;
			$(".chara-stand-item").removeClass("select-box");
			$('#' + item.unit_name).addClass('select-box');
		},
		getWidth: function(item) {
			if (this.benchmark.search_area_width != 0) {
				return this.benchmark.search_area_width - item;
			} else {
				return item;
			}

		}
	},
	created: function() {
		var self = this;
		var unit_data = new Array;
		_.forEach(self.$store.getters.getUnitData, function(value) {
			_.forEach(self.$store.getters.getCharaIdentity, function(o) {
				if (o.unit_id == value.unit_id && value.cutin_1 != "0") {
					unit_data.push(value);
				}
			});
		});
		self.unit_data = _.orderBy(unit_data, ['search_area_width', 'unit_id'], ['desc', 'desc']);
	},
	computed: {
		unitHover: function() {
			return this.unit_data;
		}
	},
	mounted: function() {
		//var position = $(".chara-stand-box").position();
		//$(".chara-stand-box").animate({
		//	left: position.left + 1000
		//}, 1000);

	}
}
</script>